export class JQueryHelper {
	public static whenReady = (jquery: string | JQuery): Promise<JQuery> => {
		const obj: JQuery = typeof jquery === 'string' ? $(jquery) : jquery;
		return new Promise<JQuery>((resolve, reject) => {
			obj.ready(() => resolve(obj));
		});
	};

	/**
	 * Searches for the next instance of selectorToFind, traversing parents if a sibling is not found
	 * Don't use this if possible to work from parent element instead
	 * @param jquery
	 * @param selectorToFind
	 */
	public static findNext(jquery: string | JQuery, selectorToFind: string) {
		return JQueryHelper.find(jquery, selectorToFind, 'next');
	}

	/**
	 * Searches for the previous instance of selectorToFind, traversing parents if a sibling is not found.
	 * Don't use this if possible to work from parent element instead
	 * @param jquery
	 * @param selectorToFind
	 */
	public static findPrevious(
		jquery: string | JQuery,
		selectorToFind: string,
	) {
		return JQueryHelper.find(jquery, selectorToFind, 'prev');
	}

	/**
	 * Traverse tree looking for next 'selectorToFind'
	 */
	private static find(
		jquery: string | JQuery,
		selectorToFind: string,
		direction: string,
	) {
		let $obj = typeof jquery === 'string' ? $(jquery) : jquery;
		let $result = $obj[direction](selectorToFind);

		if ($result.length > 0) {
			return $result;
		}

		while ($obj.length > 0) {
			$result = $obj.find(selectorToFind).slice(0, 1);
			if ($result.length > 0) {
				return $result;
			}

			if ($obj[direction](selectorToFind).length > 0) {
				return $obj[direction](selectorToFind);
			} else if ($obj[direction]().length > 0) {
				$obj = $obj[direction]();
			} else if ($obj.parent()[direction](selectorToFind).length > 0) {
				return $obj.parent()[direction](selectorToFind);
			} else {
				$obj = $obj.parent()[direction]();
			}
		}

		// empty result
		return $result;
	}

	public static focusFirstModifiableInput(element: JQuery) {
		element
			.find('input:not([readonly]), select:not([readonly])')
			.eq(0)
			.focus();
	}
}
